import { createSlice } from '@reduxjs/toolkit';
import GetPaginationQueryString from '../../utils/pageExtensions';
import Config from '../../config.js';
import GetHttpResponseError from '../../utils/httpExtensions';

export const practitionerSlice = createSlice({
    name: 'practitioner',
    initialState: {
        practitioners: []
    },
    reducers: {
        fetchPractitioner: (state, action) => {
            fetch(Config.FHIRAPIUrl + 'Practitioner/' + action.payload.id)
                .then((response) => response.json())
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        fetchPractitioners: (state, action) => {
            let paginationQuery = GetPaginationQueryString(action.payload.pagination);

            let url = Config.FHIRAPIUrl + 'Practitioner?' + paginationQuery;

            if (action.payload.organizationId)
                url += '&organizationId=' + action.payload.organizationId;
            else
                url += '&active=' + action.payload.filter.active
                    + '&address=' + action.payload.filter.address
                    + '&address-postalcode=' + action.payload.filter['address_postalcode']
                    + '&communication=' + action.payload.filter.communication
                    + '&name=' + action.payload.filter.name;

            fetch(url, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${action.payload.token}`
                }
            })
                .then((response) => {
                    GetHttpResponseError(response);

                    return response.json()
                })
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        setPractitioners: (state, action) => {
            state.practitioners = action.payload || [];
        }
    }
})

export const { setPractitioners, fetchPractitioner, fetchPractitioners } = practitionerSlice.actions

export default practitionerSlice.reducer